import { observer } from 'mobx-react-lite';
import { LinkButton, Page, PromiseContainer } from '../../../components';
import { useAccount, useStore } from '../../../store';
import usePromise from '../../../store/utils/usePromise';
import type PulseCdnStorage from '../../account/store/services/storages/PulseCdnStorage';
import ProductGrid from './components/ProductGrid';
import SellableListToolbar from './components/SellableListToolbar';

export default observer(function ProductsPage() {
  const { productStore } = useStore();
  const account = useAccount({ throwIfEmpty: false });
  const [productsPromise] = usePromise(() =>
    productStore.fetchAllProducts(true),
  );

  const isPulseCdnEnabled =
    account?.configurations.storages.findByProvider<PulseCdnStorage>(
      'pulsecdn.net',
    )?.enabled === true;

  return (
    <Page surface="transparent">
      <SellableListToolbar
        actions={
          isPulseCdnEnabled && (
            <LinkButton
              icon="cloud"
              size="small"
              sx={{ ml: 1 }}
              to="/pulsecdn"
              type="normal"
            >
              PulseCDN
            </LinkButton>
          )
        }
        createRoute="/products/create"
        sellableName="Product"
        sellables={productsPromise.value || undefined}
        tags
      />

      <PromiseContainer itemsName="products" promise={productsPromise}>
        {(value) => <ProductGrid products={value.filteredItems} />}
      </PromiseContainer>
    </Page>
  );
});
